// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[toggle-content]', (element) => {
  const content = document.querySelector(element.getAttribute('toggle-content'))

  element.addEventListener('click', (event) => {
    event.preventDefault()
    content.classList.toggle('d-none')
    element.blur()
  })
})
